const backendAddress =
  process.env.NODE_ENV !== 'production'
    ? 'http://localhost:3002/'
    : process.env.REACT_APP_BACKEND_URL;

export { backendAddress };
